"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Cancel_1 = __importDefault(require("@mui/icons-material/Cancel"));
const state_1 = require("../state");
const styles_1 = require("../styles");
const utils_1 = require("../utils");
const IncomeExpenseReportTableRow = ({ rowId, groupKey, indentation, total, periods, palette, colorLightBlue, handleReportTableCellSelect, handleClearButtonClick, showSign = false, }) => {
    const { state } = react_1.default.useContext(state_1.ReportsStateContext);
    const { selectedGraphCategory, selectedReportTableCell } = state;
    const fontWeight = indentation === 2 ? 500 : 400;
    const borderCommonStyles = (0, react_1.useMemo)(() => ({
        border: 'none',
        borderLeft: `1px solid ${palette.cloudyGrey}`,
        borderRight: `1px solid ${palette.cloudyGrey}`,
    }), [palette]);
    return (<TableRow_1.default key={rowId}>
      <styles_1.StickyTableCellLeft sx={Object.assign(Object.assign({}, borderCommonStyles), { bgcolor: palette.common.white, minWidth: 250, maxWidth: 350 })}>
        <Tooltip_1.default title={groupKey} placement="right-start">
          <Typography_1.default variant="subtitle2" ml={4 * indentation} fontWeight={fontWeight} textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">
            {groupKey}
          </Typography_1.default>
        </Tooltip_1.default>
      </styles_1.StickyTableCellLeft>
      {periods.map(({ category, txns, totalOfCategory: periodTotal, categoryIds }) => {
            const periodTotalWithSign = showSign ? -1 * periodTotal : periodTotal;
            const isSelectedCell = (0, utils_1.checkIfSelectedReportTableCellEquals)(selectedReportTableCell, rowId, category);
            return (<TableCell_1.default key={category} align="right" sx={Object.assign({ border: 'none', fontWeight, padding: 1, lineHeight: 0, position: 'relative', bgcolor: (0, utils_1.checkIfSelectedCategoryEquals)(selectedGraphCategory, category) ? colorLightBlue : 'initial' }, (!isSelectedCell && {
                    '&:hover': {
                        backgroundColor: palette.blue7,
                        cursor: 'pointer',
                    },
                }))} onClick={() => handleReportTableCellSelect(txns, rowId, category, categoryIds)}>
            {isSelectedCell && (<Box_1.default position="absolute" top={-4} left={-3}>
                <IconButton_1.default disableRipple size="small" onClick={handleClearButtonClick} sx={{ p: 0 }}>
                  <Cancel_1.default color="primary"/>
                </IconButton_1.default>
              </Box_1.default>)}
            <Box_1.default px={0.75} py={1.5} {...(isSelectedCell && {
                border: `1px solid ${palette.primary.main}`,
                bgcolor: colorLightBlue,
                borderRadius: 1,
            })}>
              {periodTotalWithSign.toFixed(2)}
            </Box_1.default>
          </TableCell_1.default>);
        })}
      <styles_1.StickyTableCellRight align="right" sx={Object.assign(Object.assign({}, borderCommonStyles), { fontWeight, bgcolor: palette.common.white })}>
        {total.toFixed(2)}
      </styles_1.StickyTableCellRight>
    </TableRow_1.default>);
};
exports.default = IncomeExpenseReportTableRow;
